// extracted by mini-css-extract-plugin
export default {"categoryText":"categoryNode_categoryText__lrPJh","active":"categoryNode_active__gTT82","inactive":"categoryNode_inactive__xofPc"};